import {
    PAYMENT_STATE_LABELS,
    PAYMENT_STATE_LABELS_ES,
  } from '../../../../commons/const/paymentStateLabels';
  
  export const getPaymentStateLabel = (stateId: string): string =>
    PAYMENT_STATE_LABELS[stateId as keyof typeof PAYMENT_STATE_LABELS] ?? stateId;
  
  export const getPaymentStateLabelEs = (state: string): string =>
    PAYMENT_STATE_LABELS_ES[state] ?? state;
  